export default {
  vehicleTypes: [
    'cart',
    'trailer',
    'truck',
    'cart-trailer',
    'cart-truck',
    'trailer-cart',
    'trailer-truck',
    'truck-cart',
    'truck-trailer',
    'trailer-cart',
    'truck-cart',
    'cart-trailer',
    'truck-trailer',
    'cart-truck',
    'trailer-truck',
    'cart-trailer-truck',
    'cart-truck-trailer',
    'trailer-cart-truck',
    'trailer-truck-cart',
    'truck-cart-trailer',
    'truck-trailer-cart',
  ],
}
